"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wopi = void 0;
const Utilities_1 = require("../Utilities");
const ProdSysBase_1 = require("./ProdSysBase");
const Instance_1 = require("../../model/Instance");
class Wopi {
    static IsUserEnabledForWopi(userInfo) {
        if (!userInfo.Fields.hasOwnProperty("ceuser.usewopi"))
            return false;
        let useWopi = userInfo.Fields["ceuser.usewopi"];
        return (useWopi.toUpperCase() === "Y");
    }
    static IsProdSysEnabledForWopi(instance) {
        let prodId = instance.items["cgdocument.prodid"].value;
        if (!prodId || prodId === "")
            return false;
        let content = instance.findContentType(Instance_1.ContentType.Normal);
        if (content != undefined) {
            let contentExt = content.contentext.valueAsString.toLowerCase();
            // Config: usewopiforprodsys.<CONTENTEXT>.<PRODID>
            if (Utilities_1.synUtil.Configs.getValue("usewopiforprodsys." + contentExt + "." + prodId, "").toUpperCase() === "Y")
                return true;
        }
        // Config: usewopiforprodsys.<PRODID>
        if (Utilities_1.synUtil.Configs.getValue("usewopiforprodsys." + prodId, "").toUpperCase() === "Y")
            return true;
        return false;
    }
    static CallAction(instance, app, action, options) {
        let instId = instance.id.valueAsString;
        let uniqueId = instance.items["cgdocument.instanzid"].value + '|' + instance.items["cgdocument.docid"].value + '|' + instance.items["cgdocument.version"].value;
        // Check if wopi is enabled for user and return accordingly
        let userInfo = Utilities_1.synUtil.UserInfo.getUserInfo();
        if (!Wopi.IsUserEnabledForWopi(userInfo))
            return new ProdSysBase_1.ActionResult(false, instId);
        // Check if wopi is enabled for prodsys
        if (!Wopi.IsProdSysEnabledForWopi(instance))
            return new ProdSysBase_1.ActionResult(false, instId);
        let chkOut = instance.items["cgdocument.chkout"].value;
        let docLockBy = instance.items["cgdocument.doclockby"].value;
        // Check if we edit (not view) the document and if it is already checked out but with a different user...
        if (action === "edit" && chkOut && docLockBy != userInfo.Id) {
            let stateId = instance.items["cgdocument.stateid"].value;
            let typeId = instance.items["cgdocument.typeid"].valueToNumber(1);
            let enableCoAuthoring = Utilities_1.synUtil.Configs.getValue("wopienablecoauthoring." + stateId, "", typeId);
            if (enableCoAuthoring === "")
                enableCoAuthoring = Utilities_1.synUtil.Configs.getValue("wopienablecoauthoring", "N", typeId);
            let wopiAdminUser = Utilities_1.synUtil.Configs.getValue("wopiuserid", undefined);
            // Co-Authoring is disabled or document is not locked by wopi admin user
            if (enableCoAuthoring === "N" || docLockBy !== wopiAdminUser) {
                // Show standard error that document is locked by other user
                $.errorDialog({ ErrorDisplayMessage: Utilities_1.synUtil.Strings.getValue("ERROR_1|1027") });
                return new ProdSysBase_1.ActionResult(true, instId);
            }
        }
        // Create access token for WOPI/MSOO and get action url
        let url = Utilities_1.synUtil.getWSUrl("CreateAccessTokenAndGetActionUrl");
        Utilities_1.synUtil.getAJAXData({
            url: url + encodeURIComponent(uniqueId) + "/" + userInfo.Id + "/" + app + "/" + action,
            done(data) {
                // e.g. https://FFC-word-view.officeapps.live.com/wv/wordviewerframe.aspx?wopisrc=https%3A%2F%2Fwopitest.technodat.at%2Fwopi%2Ffiles%2F156339&sc=view&IsLicensedUser=1
                let actionUrl = data.actionUrl + "wopisrc=" + data.wopiFilesUrl + action + "-" + uniqueId.split('|').join('-') + "&IsLicensedUser=1";
                // Construct url to open in new window
                let openWindowUrl = "wopiframe/wopiframe.html?actionurl=" + encodeURIComponent(actionUrl) + "&accesstoken=" + data.accessToken + "&accesstokenttl=" + data.accessTokenTTL;
                if (data.favIconUrl && data.favIconUrl !== "")
                    openWindowUrl += "&faviconurl=" + encodeURIComponent(data.favIconUrl);
                // Store url required for business flow for logging in and redirecting
                url = Utilities_1.synUtil.getWSUrl("SetRequestUrl");
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: url,
                    requestData: {
                        accessToken: JSON.stringify(data.accessToken),
                        requestUrl: JSON.stringify(openWindowUrl)
                    },
                    done() {
                        // Open window/tab with iframe for MSOO
                        if (options != undefined && options.newWindow != undefined && options.newWindow == false)
                            window.open(openWindowUrl, "_self");
                        else
                            window.open(openWindowUrl); // default
                    }
                });
            }
        });
        return new ProdSysBase_1.ActionResult(true, instId);
    }
}
exports.Wopi = Wopi;
